import { render, staticRenderFns } from "./InspectionCreateCardRemark.vue?vue&type=template&id=600c70a3&"
import script from "./InspectionCreateCardRemark.vue?vue&type=script&lang=ts&"
export * from "./InspectionCreateCardRemark.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports